import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import Typography from "@material-ui/core/Typography";
import * as ENUM from "@dpdgroupuk/redback-enums";
import OptionItem from "./OptionItem";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  wrapper: {
    [breakpoints.down("sm")]: {
      margin: `${typography.pxToRem(150)} ${typography.pxToRem(10)} ${typography.pxToRem(40)}`
    },
    backgroundColor: palette.background.dialogSecondary,
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    marginTop: typography.pxToRem(120),
    paddingTop: typography.pxToRem(10),
    paddingBottom: typography.pxToRem(30),
    minHeight: typography.pxToRem(330),
    maxWidth: typography.pxToRem(900),
    borderRadius: 2.5
  },
  container: {
    [breakpoints.down("sm")]: {
      padding: "0 40px"
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 50px"
  },
  title: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(16)
    },
    marginBottom: typography.pxToRem(10),
    fontSize: typography.pxToRem(20),
    lineHeight: 1.49,
    letterSpacing: "0.44px"
  },
  subtitle: {
    color: palette.text.subtitle,
    marginBottom: typography.pxToRem(35)
  },
  optionsContainer: {
    [breakpoints.down("sm")]: {
      flexDirection: "column"
    },
    display: "flex",
    flexDirection: "row"
  },
  divider: {
    [breakpoints.down("sm")]: {
      display: "none"
    },
    width: typography.pxToRem(1.6),
    height: "inherit",
    backgroundColor: palette.text.primary,
    marginRight: typography.pxToRem(50),
    opacity: 0.3,
    marginTop: typography.pxToRem(10),
    marginBottom: typography.pxToRem(45),
    borderRadius: typography.pxToRem(2)
  },
  withAdditionalMargin: {
    marginBottom: typography.pxToRem(45)
  }
}));

const OptionsList = ({
  actions,
  onOptionSelect,
  width,
  title,
  subtitle = "",
  unavailableOptionText,
  getOptionIcon,
  actionSubtitles = []
}) => {
  const {
    availableActions = [],
    unavailableActions = [],
    availableActionsName = [],
    unavailableActionsName = []
  } = actions;
  const actionsCodes = [...availableActions, ...unavailableActions];
  const actionsNames = [...availableActionsName, ...unavailableActionsName];
  const options = actionsCodes.map((code, index) => ({
    code,
    name: actionsNames[index],
    isNotAvailable: unavailableActions.includes(code),
    subtitle: actionSubtitles[code]
  }));
  const pickupActionAvailable = availableActions.includes(ENUM.PARCEL_ACTION_CODE.PKU);
  const styles = useStyles();
  const optionsList = React.useMemo(() => options.map((action, index) => {
    const isPickupAction = action.code === ENUM.PARCEL_ACTION_CODE.PKU;
    const withAdditionalMargin = isPickupAction || pickupActionAvailable && isWidthUp("md", width) && index === 1;
    return /*#__PURE__*/React.createElement(OptionItem, {
      key: action.code,
      action: action,
      getOptionIcon: getOptionIcon,
      onClick: () => onOptionSelect(action.code.toLowerCase()),
      unavailableOptionText: unavailableOptionText,
      isOptionBestForPlanet: isPickupAction,
      className: clsx(withAdditionalMargin && styles.withAdditionalMargin)
    });
  }), [options, getOptionIcon, unavailableOptionText, pickupActionAvailable, width, styles.withAdditionalMargin, onOptionSelect]);
  const isTwoColumns = optionsList.length > 1 && isWidthUp("md", width);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.title, styles.subtitle)
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: styles.optionsContainer
  }, isTwoColumns ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.optionsColumn
  }, optionsList.filter((item, index) => !(index % 2))), /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.optionsColumn
  }, optionsList.filter((item, index) => index % 2))) : /*#__PURE__*/React.createElement("div", {
    className: styles.optionsColumn
  }, optionsList))));
};

export default withWidth()(OptionsList);